module.exports = __webpack_public_path__ + "static/img/accidental_cyberpic.35711c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/drawing_painting/accidental_cyberpic.jpg
// module id = u6s4
// module chunks = 1